module.exports = __webpack_public_path__ + "img/icon_clock.d55cecaf.svg";